function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { SCPactometroCheck } from "./style.js";
import { number, string, shape, func, arrayOf } from "prop-types";
import CheckImg from "../../assets/check.png";

const PactometroCheck = ({
  data,
  onChange,
  selecteds = [],
  cols
}) => {
  const _useState = useState(selecteds),
        _useState2 = _slicedToArray(_useState, 2),
        selectedsId = _useState2[0],
        setSelectedsId = _useState2[1];

  const onchange = id => {
    let selecteds = _toConsumableArray(selectedsId);

    if (selectedsId.some(select => select === id)) {
      selecteds = selecteds.filter(item => item !== id);
    } else {
      selecteds = [].concat(_toConsumableArray(selecteds), [id]);
    }

    setSelectedsId(selecteds);
    onChange(selecteds);
  };

  useEffect(() => {
    setSelectedsId(selecteds);
  }, [selecteds]);
  return React.createElement(SCPactometroCheck, {
    cols: cols,
    labelCheckImage: CheckImg
  }, data && data.map(item => React.createElement("div", {
    key: JSON.stringify(item),
    className: "row-pactometro",
    role: "presentation",
    onClick: () => onchange(item.id)
  }, React.createElement("input", {
    type: "checkbox",
    onChange: () => {},
    checked: selectedsId.some(select => select === item.id)
  }), React.createElement("label", {
    style: {
      borderLeft: "10px solid ".concat(item.partyColor, " ")
    }
  }, React.createElement("span", null, item.partyAcronym), React.createElement("p", null, " ", item.seats, " esca\xF1os")))));
};

PactometroCheck.propTypes = {
  data: arrayOf(shape({
    partyAcronym: string.isRequired,
    seats: number.isRequired,
    partyColor: string.isRequired,
    votes: number.isRequired,
    id: number.isRequired
  })).isRequired,
  onChange: func.isRequired,
  cols: number
};
export default PactometroCheck;